import { useState, useEffect, useRef } from "react";
import "../../assets/css/gamehis.module.css";
import socket from "../Components/socket";
import { BsFillEyeFill } from "react-icons/bs";
import AppLoader from "../Components/AppLoader";
import { apiRequest } from "../../apiService/allApi";

const Transactionhistory = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCardId, setSelectedCardId] = useState(null);

  const [user, setUser] = useState("");

  let limit = 50;
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  const role = async () => {
    socket.emit("getprofile");

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    const res = await apiRequest(`me`, "GET", null, headers);

    setUser(res.data);

    Allgames(res.data._id, pageNumber, limit);
  };

  const [cardData, setGame] = useState();

  const Allgames = async (id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    setIsLoading(true);

    const res = await apiRequest(
      `user/deposite/${id}?page=${pageNumber}&_limit=${limit}`,
      "GET",
      null,
      headers,
    );

    setGame(res.data.ress);

    setNumberOfPages(res.data.totalPages);
    setIsLoading(false);
  };

  useEffect(() => {
    role();
    //eslint-disable-next-line
  }, [pageNumber, limit]);

  const [Withdrawal, setWithdrawal] = useState();
  const [showBottom, setShowBottom] = useState(false);

  const handleCloseBottom = () => setShowBottom(false);
  const handleShowBottom = (data) => {
    setShowBottom(true);
    setWithdrawal(data);
  };

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    const time = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });

    return `${newDate}, ${time}`;
  };
  return (
    <>
      <div>
        {isLoading ? (
          <div className="text-center">
            {cardData && cardData.length === 0 ? (
              <div className="mt-2">
                <h3 className="font-weight-bold">No transaction History</h3>
                <p className="text-muted">
                  You have not made any transaction yet.
                </p>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "60px 0",
                }}
              >
                <AppLoader
                  size="lg"
                  color="primary"
                  text="Loading transaction history..."
                />
              </div>
            )}
          </div>
        ) : (
          cardData &&
          cardData.length === 0 && (
            <div className="mt-2 text-center">
              <h3 className="font-weight-bold">No transaction History</h3>
              <p className="text-muted">
                You have not made any transaction yet.
              </p>
            </div>
          )
        )}

        <div className="transaction_main_section_modal mb-sm-5">
          {cardData &&
            cardData.map((card) => {
              return (
                <>
                  <div className="tx-card-container mt-3">
                    <div className="tx-date-box">
                      <div className="tx-icon-bg">
                        <img alt="date" src="/images/date-time.png" />
                      </div>
                      <div className="tx-date-text text-center">
                        <span className="tx-day">
                          {dateFormat(card.createdAt).split(",")[0]}
                        </span>
                        <span className="tx-time">
                          {dateFormat(card.createdAt).split(",")[1]}
                        </span>
                      </div>
                    </div>

                    <div className="tx-details">
                      <div className="tx-header">
                        <span
                          className={`tx-type-badge ${card.Req_type === "withdraw" ? "type-withdraw" : "type-deposit"}`}
                        >
                          {card.Req_type === "withdraw"
                            ? "WITHDRAW"
                            : "DEPOSIT"}
                        </span>
                        <span
                          className={`tx-status ${
                            card.status === "none" || card.status === "Pending"
                              ? "status-processing"
                              : "status-done"
                          }`}
                        >
                          ●{" "}
                          {card.status === "none" || card.status === "Pending"
                            ? "Processing"
                            : card.status}
                        </span>
                      </div>

                      <p className="tx-msg">
                        {card.txn_msg || "Transaction recorded successfully"}
                      </p>

                      {card?.Req_type === "withdraw" && (
                        <div className="tx-info-viewer">
                          <button
                            className="eye-btn"
                            onClick={() =>
                              setSelectedCardId((prevId) =>
                                prevId === card._id ? null : card._id,
                              )
                            }
                          >
                            <BsFillEyeFill />{" "}
                            {selectedCardId === card._id
                              ? "Hide Details"
                              : "View Details"}
                          </button>
                          {selectedCardId === card._id && (
                            <div className="details-popup">
                              {card?.upiId ? (
                                <p>
                                  UPI: <span>{card?.upiId}</span>
                                </p>
                              ) : (
                                <p>
                                  A/C: <span>{card?.account_number}</span> |
                                  IFSC: <span>{card?.ifsc_code}</span>
                                </p>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    <div className="tx-financials">
                      <div
                        className={`tx-amount ${card.Req_type === "withdraw" ? "amt-neg" : "amt-pos"}`}
                      >
                        {card.Req_type === "withdraw" ? "-" : "+"} ₹
                        {card.amount}
                      </div>
                      {card.closing_balance && (
                        <div className="tx-closing-bal">
                          <label>Balance</label>
                          <span>₹{card.closing_balance}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              );
            })}
        </div>
        <div></div>
      </div>
    </>
  );
};

export default Transactionhistory;
